module.exports = __webpack_public_path__ + "img/4.c48955e5.png";